export const newsConstants={
    list:{
        fields:{
            id:"ID",
            title:"NewsTitle",
            brief:"NewsBrief",
            description:"NewsDescription",
            expirationDate:"NewsExpirationDate",
            picture:"NewsPicture",
            modifiedDate : "Modified"
        }
    }
    ,
    camlQuery:{
        newsList:`
    <View>  
        <Query> 
            <Where>
                <Geq>
                    <FieldRef Name='NewsExpirationDate' /><Value Type='DateTime'><Today /></Value>
                </Geq>
            </Where>
            <OrderBy>
                <FieldRef Name='Modified' Ascending='FALSE' />
            </OrderBy> 
        </Query> 
        <ViewFields>
            <FieldRef Name='ID' />
            <FieldRef Name='NewsTitle' />
            <FieldRef Name='NewsBrief' />
            <FieldRef Name='Modified' />
            <FieldRef Name='NewsDescription' />
            <FieldRef Name='NewsExpirationDate' />
            <FieldRef Name='NewsPicture' />
        </ViewFields> 
        <RowLimit>{{numberPageSize}}</RowLimit> 
    </View>`,
    newsHome:`
    <View>  
        <Query> 
            <Where>
                <Geq>
                    <FieldRef Name='NewsExpirationDate' /><Value Type='DateTime'><Today /></Value>
                </Geq>
            </Where>
            <OrderBy>
                <FieldRef Name='Modified' Ascending='FALSE' />
            </OrderBy> 
        </Query> 
        <ViewFields>
           <FieldRef Name='ID' />
            <FieldRef Name='NewsTitle' />
            <FieldRef Name='NewsBrief' />
            <FieldRef Name='NewsDescription' />
            <FieldRef Name='NewsExpirationDate' />
            <FieldRef Name='NewsPicture' />
        </ViewFields> 
        <RowLimit>4</RowLimit> 
    </View>`
},
    slash : "/"
}